import { defineMessages } from 'react-intl-next';

export const messages: {
	avatarToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	iconToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	labelToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	publishDateToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	socialStatsToggleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	publishDateToggleLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label-v2',
		defaultMessage: 'Last updated',
		description:
			'A visible label for the toggle to display/hide publish date for type text based link card',
	},
	avatarToggleLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label-v2',
		defaultMessage: 'Content owner',
		description:
			'A visible label for the toggle to display/hide avatar for type text based link card',
	},
	labelToggleLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.label.label-v2',
		defaultMessage: 'Label',
		description:
			'A visible label for the toggle to display/hide label for type text based link card',
	},
	descriptionToggleLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.ai-description.label-v2',
		defaultMessage: 'Description',
		description:
			'A visible label for the toggle to display/hide AI description for type text based link card',
	},
	socialStatsToggleLabel: {
		id: 'company-hub.cards-extension.card-config-panel.content-section.display-options.social-stats-toggle-label',
		defaultMessage: 'Social stats',
		description:
			'A visible label for the toggle to display/hide social stats for type text based link card',
	},
	iconToggleLabel: {
		id: 'company-hub.cards-extension.card-config-panel.content-section.display-options.icon-toggle-label',
		defaultMessage: 'Icon',
		description:
			'A visible label for the toggle to display/hide icon for type text based link card',
	},
});
